import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["src", "alt"]

import { computed, inject } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BrandsList',
  setup(__props) {

const displayWidth: any = inject(`displayWidth`);
const store: any = inject(`store`);

const logoArray = computed(() => {
  return store.getters.getCompaniesLogo;
});

const computedDisplayWidth = computed(() => {
  return displayWidth.value < 700;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({brandList:true, mobile:computedDisplayWidth.value})
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logoArray.value, (logo) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "logoWrapper",
        key: logo.alt
      }, [
        _createElementVNode("a", {
          class: "anchor",
          href: logo.href,
          target: "_blank"
        }, [
          _createElementVNode("img", {
            class: "logo",
            src: logo.src,
            alt: logo.alt
          }, null, 8, _hoisted_2)
        ], 8, _hoisted_1)
      ]))
    }), 128))
  ], 2))
}
}

})